import React from "react"

import { Control } from "react-hook-form"

import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface RatingOption {
  value: string
  label: string
}

interface RatingSelectProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  name: string
  label: string
  options?: RatingOption[]
  calculateResult: () => void
}

const defaultRatingOptions = [
  { value: "Up to Standard", label: "Up to Standard" },
  { value: "Satisfactory", label: "Satisfactory" },
  { value: "Needs Improvement", label: "Needs Improvement" },
  { value: "Failed Protocol", label: "Failed Protocol" },
]

const RatingSelect: React.FC<RatingSelectProps> = ({
  control,
  name,
  label,
  options = defaultRatingOptions,
  calculateResult,
}) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(value) => {
              field.onChange(value)
              calculateResult()
            }}
            defaultValue={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select score" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {options.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FormItem>
      )}
    />
  )
}

export default RatingSelect
